


































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component({})
export default class ConflictModal extends Vue {
    @Prop()
    show: boolean;
    @Prop()
    conflictList: any[];
    @Prop()
    unConflictList: any[];
    @Prop({ required: true, default: { categoryIds: [] } })
    transferParams: any;

    visible: boolean = false;
    tableData: any = [];
    showConflictTable: boolean = false;
    showUnConflictTable: boolean = false;

    @Watch('show')
    showHandler(val) {
        this.visible = val;
    }

    @Watch('conflictList')
    handleConflictList(val) {
        this.getConflictData(val);
    }

    getConflictData(val) {
        this.tableData = val.map(item => {
            item.conflictName = `${item.categoryName}/${item.typeName}/${item.itemName}`;
            return item;
        });
    }

    showTable(name) {
        this[name] = !this[name];
    }

    closeModal() {
        this.$emit('closeModal');
    }

    confirm() {
        this.$emit('closeModal');
        this.$emit('confirm', this.transferParams);
    }
}
